var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://t.me/alanverne","target":"_blank"}},[_vm._v("Telegram")])}
var staticRenderFns = []

export { render, staticRenderFns }